import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "radioButton",
    "submitButton",
    "container",
    "hint"
  ]

  static values = {
    bookable: {
      type: Boolean,
      default: false
    }
  }

  toggleAndScrollToSubmitButton (event) {
    const radioButtonValue = this.getRadioButtonValue(event)
    if (radioButtonValue === true) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove('disabled')
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add('disabled')
    }
    if (this.hasHintTarget) this.hintTarget.hidden = radioButtonValue === true
    const container = this.containerTarget
    const submitButton = this.submitButtonTarget
    const containerRect = container.getBoundingClientRect()
    const buttonRect = submitButton.getBoundingClientRect()

    // Calculate how far the button is from the bottom of the container
    const buttonBottom = buttonRect.bottom - containerRect.top
    const scrollAmount = buttonBottom - container.clientHeight

    if (scrollAmount > 0) {
      container.scrollTo({
        top: container.scrollTop + scrollAmount,
        behavior: 'smooth'
      })
    }
  }

  getRadioButtonValue (event) {
    return event.target.closest(".choice-card").querySelector("input[type='radio']").checked
  }
}
